
















import { Prop, Component, Vue } from "vue-property-decorator";
import ProjectManagerTableItem from "../viewmodels/project-manager-table-item";
import ProjectManagerTable from "../components/project/ProjectManagerTable.vue";

@Component({
  components: {
    ProjectManagerTable
  }
})
export default class ProjectManagerSelect extends Vue {
  @Prop({ default: () => [] }) selectedIds!: number[];
  @Prop({ default: () => [] }) items!: ProjectManagerTableItem[];
  checkAllStatus: boolean = false;

  data() {
    return {
      checkAllStatus: false
    };
  }
  select(selectedIds: number[]) {
    this.$emit("select", selectedIds);
  }
  // 全チェックのON/OFFで、全てのチェックボックスをON/OFF
  checkAll(checkBoxStatus: boolean) {
    if (checkBoxStatus == true) {
      // console.log("UnCheckAll: 全チェック True なら、全部のチェックを外す");
      this.select([]);
    } else {
      // console.log("CheckAll: 全チェック False なら、全部のチェックをつける");
      this.select(this.items.map(item => item.id));
    }
  }

  created() {
    // Fillter Staff is_hidden_info
    this.items = this.items.filter(item => item.isHiddenInfo === 0);
  }
}
